import React, { useState} from 'react';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { alpha, styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { visuallyHidden } from '@mui/utils';
import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import CancelIcon from '@mui/icons-material/Cancel';
import funcionOrdenarColumnas from '../eventos/filtros/OrdenarColumnas';
import BotonesAccion from '../eventos/navegacion_y_accion/BotonesAccion';
import CustomTooltip from '../eventos/avisos/Tooltip';
import IconosGenerales from "../iconos/IconosGenerales";
import BuscadorCategorias from '../eventos/filtros/BuscadorDinamico';
import PaginacionTabla from '../eventos/filtros/SelectPaginaTabla';
import SelectNumeroCategorias from '../eventos/filtros/SelectNumeroElementos';


const StyledTableCell = styled(TableCell)(({ theme, textDefault }) => ({
    textAlign: 'center  !important',
    //white-space: nowrap;       /* Evita que el texto salte de línea */
    maxWidth:'50px !important',
    overflow:'hidden',
    textOverflow: 'ellipsis',
    paddingInlineEnd: '1px !important',
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'rgba(0, 60, 102, 0.8)',
        color: theme.palette.common.white,
        padding: '0px',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: '14px ',
        textTransform: textDefault ? 'none' : 'capitalize',
        padding: '0px',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    textAlign: 'center  !important',
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const WhiteTableSortLabel = styled(TableSortLabel)(({ theme }) => ({
    textAlign: 'center  !important',
    color: `${theme.palette.common.white} !important`,
    '&.Mui-active .MuiTableSortLabel-icon': {
        color: `${theme.palette.common.white} !important`,
    },
}));


function stableSort(array, comparator) {
    const arrayCopy = [...array];
    arrayCopy.sort(comparator);
    return arrayCopy;
}

function EnhancedTableHead(props) {

    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <StyledTableRow>
                <StyledTableCell padding="checkbox">
                    <Checkbox
                        style={{ color: 'white' }}
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    />
                </StyledTableCell>
                {props.header.map((headCell) => (
                    <StyledTableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <WhiteTableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </WhiteTableSortLabel>
                    </StyledTableCell>
                ))}
            </StyledTableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
    const { numSelected, setEliminarCatSelect, setEliminarTodoCategorias, isLoading } = props;
    const [estadoBusqueda, setEstadoBusqueda] = useState(false);
    const [escribiendo, setEscribiendo] = useState(false);
    console.log("cargando", isLoading);

    const toggleFiltroTodos = (valor, atributo) => {
        console.log("Activar todos");
        console.log("atributo ", atributo);

        if (atributo == "ocultar") {

            setEliminarTodoCategorias((prevState) => ({
                ...prevState,
                valor,
            }));
        }

    };

    const toggleSeleccion = (valor, atributo) => {

        if (atributo == "ocultar") {

            setEliminarCatSelect((prevState) => ({
                ...prevState,
                valor,
            }));

        }
    };

    return (
        <>
            <Toolbar
                sx={{
                    pl: { sm: 2 },
                    pr: { xs: 1, sm: 1 },
                    ...(numSelected > 0 && {
                        bgcolor: (theme) =>
                            alpha(theme.palette.common.white, theme.palette.action.activatedOpacity),
                    }),
                }}
            >
                {numSelected > 0 ? (
                    <Typography
                        sx={{ flex: '1 1 100%' }}
                        color="inherit"
                        variant="subtitle1"
                        component="div"
                    >
                        {numSelected} seleccionado(s)
                    </Typography>
                ) : (
                    <Typography
                        sx={{ flex: '1 1 40%' }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >

                        <BotonesAccion
                            texto="Crear Categoría"
                            
                            to="/comunicacion/categorias/crearCategoria"
                        />
                    </Typography>
                )}

                {numSelected > 0 ? (
                    <>
                        {[
                            { mensaje: "Eliminar página actual", id: "eliminarTodo", handler: () => toggleFiltroTodos(false, "ocultar") },
                            { mensaje: "Eliminar select", id: "eliminarSelect", handler: () => toggleSeleccion(false, "ocultar") },
                        ].map(({ mensaje, id, handler }) => (
                            <CustomTooltip key={id} mensaje={mensaje}>
                                <div
                                    onClick={handler}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        width: '40px',
                                        height: '40px',
                                    }}
                                >
                                    <IconosGenerales papeleraT="true" id={id} style={{ width: '40px', height: '40px' }} />
                                </div>
                            </CustomTooltip>
                        ))}
                    </>
                ) : (
                    <>
                        <BuscadorCategorias
                            placeholder="Buscar Categoría"
                            tooltip="Ej: Nombre"
                            palabra=""
                            estadoBusqueda={estadoBusqueda}
                            setEstadoBusqueda={setEstadoBusqueda}
                            escribiendo={escribiendo}
                            setEscribiendo={setEscribiendo}
                        />
                    </>
                )}
            </Toolbar>
        </>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

function EnhancedTable(props) {
    console.log("Props", props);
    const navigate = useNavigate();
    const {
        data,
        header,
        meta,
        selected,
        setSelected,
        setEliminarTodoCategorias,
        setEliminarCatSelect,
        isLoading
    } = props;


    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('categoria');


    const handleRequestSort = (event, property) => {
        const nuevaURL = funcionOrdenarColumnas(orderBy, order, setOrderBy, setOrder)(event, property);
        console.log("nuevaURL", nuevaURL);
        navigate(nuevaURL);
    };


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = data.map((n) => n.id);
            setSelected(newSelected);

            return;
        }
        setSelected([]);
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const isSelected = (id) => selected.indexOf(id) !== -1;

    const sortedData = stableSort(data);

     return (
        <Box sx={{ width: '100%' }}>
            <div>
                <Paper sx={{ width: '98%', mb: 2 }}>

                    <EnhancedTableToolbar
                        numSelected={selected.length}
                        setEliminarTodoCategorias={setEliminarTodoCategorias}
                        setEliminarCatSelect={setEliminarCatSelect}
                        isLoading={isLoading}
                    />

                    <TableContainer  >
                        <Table sx={{ maxWidth: 2000, minWidth: 1300, }} aria-labelledby="tableTitle">
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={data.length}
                                header={header}
                            />
                            <TableBody>
                                {isLoading ? (
                                    <TableRow hover sx={{ cursor: "default" }}>
                                        <TableCell colSpan={13} style={{ textAlign: "center" }}>
                                            <CircularProgress style={{ color: "rgba(0, 60, 102, 0.8)" }} />
                                        </TableCell>
                                    </TableRow>
                                ) : ( console.log("data ", data),
                                    sortedData.map((row, index) => {
                                        const isItemSelected = isSelected(row.id);
                                        const labelId = `enhanced-table-checkbox-${index}`;

                                        return (
                                            <StyledTableRow
                                                hover
                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                key={row.id}
                                                selected={isItemSelected}
                                            >
                                                <StyledTableCell padding="checkbox">
                                                    <Checkbox
                                                        color="default"
                                                        onClick={(event) => handleClick(event, row.id)}
                                                        checked={isItemSelected}
                                                        inputProps={{ 'aria-labelledby': labelId }}
                                                    />
                                                </StyledTableCell>

                                                

                                                <StyledTableCell
                                                    component="th"
                                                    id={labelId}
                                                    scope="row"
                                                    padding="none"
                                                >
                                                    {row.categoria}
                                                </StyledTableCell>

                                                <StyledTableCell
                                                    component="th"
                                                    id={labelId}
                                                    scope="row"
                                                    padding="none"
                                                    
                                                >
                                                    {row.descripcion}
                                                </StyledTableCell>


                                                <StyledTableCell align="right"> <IconosGenerales
                                                    tabla="true"
                                                    id="edit"
                                                    to={`/comunicacion/categorias/editarCategoria/${row.editar}`}
                                                /></StyledTableCell>
                                            </StyledTableRow>
                                        );
                                    })
                                )}
                            </TableBody>

                        </Table>
                    </TableContainer>

                </Paper>
            </div>

            {!isLoading && (
                <>
                    <PaginacionTabla totalPages={meta.totalPages} />
                                        <SelectNumeroCategorias perPage={meta.per_page} />
                </>
            )}

            <Typography
                variant="body2"
                sx={{
                    mr: '2%',
                    textAlign: 'right',
                    fontWeight: 'bold',
                    fontSize: '16px',
                    gap: "8px", marginTop: "-30px",
                    color: 'rgba(0, 60, 102, 0.8)',
                }}
            >
                Total registros: {meta.total || 0}
            </Typography>
        </Box>
    );
}


EnhancedTable.propTypes = {
    data: PropTypes.array.isRequired,
    header: PropTypes.array.isRequired,
    meta: PropTypes.object.isRequired,
};

export default EnhancedTable;